import { render, staticRenderFns } from "./AdicionarLead.vue?vue&type=template&id=961632a8"
import script from "./AdicionarLead.vue?vue&type=script&lang=ts"
export * from "./AdicionarLead.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports